import http from "../axios/http-common";

class InterfaceNyeri {
  getNyeri(rm) {
    return http.getData(`/rm/${rm}/nyeri`);
  }
  getNyeriByReg(unit, reg) {
    return http.getDataParam(`/register/${reg}/nyeri`, {
      params: {
        unit_id: unit
      }
    });
  }

  saveNyeri(reg, unit_id, rm, param) {
    console.log(param);
    return http.postData(`/nyeri`, {
      register_id: reg,
      unit_id: unit_id,
      pasien_rm: rm,
      // nyeri: {
      skala: param["nyeri"]["skala"],
      metode: param["nyeri"]["metode"],
      question: param["nyeri"]["question"],
      lokasi: param["nyeri"]["lokasi"],
      // intensitas: param['nyeri']['intensitas'],
      durasi: param["nyeri"]["durasi"],
      frekuensi: param["nyeri"]["frekuensi"],
      pencetus: param["nyeri"]["pencetus"],
      kualitas: param["nyeri"]["kualitas"],
      pola_serangan: param["nyeri"]["pola_serangan"],
      penyebab_hilang: param["nyeri"]["penyebab_hilang"],
      jenis: param["nyeri"]["jenis"],
      user_id: param["nyeri"]["user"]["id"]
      // }
    });
  }

  editNyeri(id, reg, unit_id, rm, param) {
    return http.putData(`/nyeri/${id}`, {
      register_id: reg,
      unit_id: unit_id,
      pasien_rm: rm,
      // id: param['nyeri']['id'],
      skala: param["nyeri"]["skala"],
      metode: param["nyeri"]["metode"],
      question: param["nyeri"]["question"],
      lokasi: param["nyeri"]["lokasi"],
      // intensitas: param['nyeri']['intensitas'],
      durasi: param["nyeri"]["durasi"],
      frekuensi: param["nyeri"]["frekuensi"],
      pencetus: param["nyeri"]["pencetus"],
      kualitas: param["nyeri"]["kualitas"],
      pola_serangan: param["nyeri"]["pola_serangan"],
      penyebab_hilang: param["nyeri"]["penyebab_hilang"],
      jenis: param["nyeri"]["jenis"],
      user_id: param["nyeri"]["user"]["id"]
    });
  }
}
export default new InterfaceNyeri();
